import { useRef } from 'react';
import { useC3Chart } from '../../hooks/useC3Chart';
import { groupSmallSegments, type LabelValue } from '../../utilities/chartData';
import { formatBytes } from '../../utilities/format';

interface Props {
  title: string;
  data: LabelValue[];
  valueType: 'bytes' | 'count';
  onItemClick?: (label: string) => void;
}

export function PieChartPanel({ title, data, valueType, onItemClick }: Props) {
  const chartRef = useRef<HTMLDivElement>(null);
  const onItemClickRef = useRef(onItemClick);
  onItemClickRef.current = onItemClick;

  useC3Chart(chartRef, () => {
    if (!data.length) return null;
    const segments = groupSmallSegments(data);
    return {
      data: {
        columns: segments.map(d => [d.label, d.value]),
        type: 'pie',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onclick: (d: any) => { if (d.id !== 'Other') onItemClickRef.current?.(d.id); },
      },
      tooltip: {
        format: {
          value: (value: number) =>
            valueType === 'bytes' ? formatBytes(value) : value.toLocaleString(),
        },
      },
      interaction: { brighten: false },
    };
  }, [data, valueType]);

  return (
    <div className="col-md-5 text-center">
      <h2>{title}</h2>
      <div ref={chartRef} />
    </div>
  );
}
